// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__2ZWJh","noFill":"button_noFill__1z8ki","bordered":"button_bordered__1tVBO","indented":"button_indented__3A0w6","disabled":"button_disabled__19rMQ"};